







































































































































































































































import Vue from 'vue'
import AlertModal from '../atoms/AlertModal.vue'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import ReturnButton from '../atoms/ReturnButton.vue'
import TakePicture from '../organisms/TakePicture.vue'
import PictureUtil from '../../utils/take_picture/picture_util'
import SubmitFlow from '../organisms/SubmitFlow.vue'
import { QR_MAP, QRInfo } from '../../utils/take_picture/qr_map'
import Stepps from '../organisms/Stepps.vue'
import QrReader from '../organisms/QrReader.vue'
import { TestInfo, IndividualTestStatus } from '../../utils/service/KoushiSite'
import axios from 'axios'
import { isEqual } from 'lodash'

export type ImageType = '' | 'first' | 'second'
export type State = 'QR' | 'Picture' | 'Preview' | 'NumCheck' | 'Complete'

export type DataType = {
  showContent: boolean
  showSubmit: boolean
  showQRModal: boolean
  showPictureModal: boolean
  width: number | null
  // first：表 or 1枚目、 second：裏 or 2枚目
  imageType: ImageType
  // QR：二次元コード読み取り、Picture：カメラ撮影, NumCheck： 数字切り出し画像の入力, Complete： 完了
  state: State
  errorMessage: string
  cutOutNumber: string
  cutOutNumberError: string
  // 撮影した画像のbase64URL
  base64ImageUrl: string
  // 確認OKとなった画像のbase64URL ([0]が表、[1]が裏)
  submittedBase64ImageUrl: (string | null)[]
  // クリックした数字のbase64URL
  numCheckImageUrl: string
  // 画像アップロード中
  uploading: boolean
  // 画像回転中
  rotating: boolean
  // QR読み取りタイムアウト処理
  showQRTimeout: any
  dummyQRCode: string
  stepps: string[][] | []
}

export default Vue.extend({
  components: {
    AlertModal,
    TakePicture,
    TitleName,
    ModalPanel,
    ReturnButton,
    Stepps,
    QrReader,
    SubmitFlow
  },
  data(): DataType {
    return {
      showContent: false,
      showSubmit: false,
      showQRModal: false,
      showPictureModal: false,
      width: null,
      imageType: 'first',
      state: 'QR',
      errorMessage: '',
      cutOutNumber: '',
      cutOutNumberError: '',
      base64ImageUrl: '',
      submittedBase64ImageUrl: [null, null],
      numCheckImageUrl: '',
      uploading: false,
      rotating: false,
      showQRTimeout: null,
      dummyQRCode: '',
      stepps: []
    }
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    titleName(): string {
      if (this.state === 'Complete') return 'テスト提出完了'
      return 'テスト提出'
    } ,
    isMAGAZINE(): boolean {
      if (this.displayForMember) return true;
      return this.$store.state.examInfo.type === 'MAGAZINE'
    },
    // モックは小学館思考力テストのみ対応
    imageTypeToText(): { [key in ImageType]: string } {
      return {
        '': '',
        'first': '表面',
        'second': '裏面',
      }
    },
    currentStepp() :number {
      const currentSteppArray = this.state === 'Complete' ? [this.state] : [this.imageType, this.state]
      return this.stepps.findIndex((array: any) => isEqual(array, currentSteppArray)) + 1
    },
    envCheckUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/device/`
    },
    curretStateTitle(): string {
      if (this.state === 'QR') {
        return '二次元コード読み取り'
      } else if (this.state === 'Picture') {
        return '撮影'
      } else if (this.state === 'Preview') {
        return '確認'
      } else if (this.state === 'NumCheck') {
        return '撮影 番号読み取り'
      } else if (this.state === 'Complete') {
        return '完了'
      }
      return ''
    },
    testName(): string {
      if (!this.testInfo) return ''

      const monthText = this.displayForMember ? `${this.testInfo.month}月号 ` : ''
      if (this.testInfo.name.includes('思考力')) {
        return monthText + '小学館思考力テスト'
      } else if (this.testInfo.name.includes('実力診断')) {
        return monthText + '学年末実力診断テスト'
      } else {
        return monthText + this.testInfo.name
      }
    },
    currentSideName(): string {
      return this.imageTypeToText[this.imageType]
    },
    instructionMessage(): string {
      if (this.state === 'Complete') {
        return `${this.testName}${this.stateMessage}`
      } else if (this.state === 'NumCheck') {
        return `確認のため以下に表示されている数字を入力してください。`
      } else if (this.isMAGAZINE) {
        return `${this.testName} <font color="red">${this.currentSideName}</font>${this.stateMessage}`
      } else {
        if (this.state === 'QR') return `${this.testName} <font color="red">${this.isMAGAZINE ? this.currentSideName : 'テスト撮影時'}</font>${this.stateMessage}`
        return `${this.testName}${this.stateMessage}`
      }
    },
    stateMessage(): string {
      if (this.state === 'QR') {
        if (this.isMAGAZINE) return 'の二次元コードを読み取ってください。'
        return '<font color="red">の二次元コード</font>を読み取ってください。'
      } else if (this.state === 'Picture') {
        return 'を撮影してください。'
      } else if (this.state === 'Preview') {
        return 'の確認を行ってください。'
      } else if (this.state === 'NumCheck') {
        return 'を撮影してください。'
      } else if (this.state === 'Complete') {
        return 'の提出が完了しました。'
      }
      return ''
    },
    displayForMember(): boolean {
      return this.$store.state.isMemberPage
    },
    submitTestPath(): string {
      return this.displayForMember
        ? "/tensaku/"
        : "/tensaku_visiter/"
    },
    submitNumberText(): string {
      if (this.isMAGAZINE && this.imageType === 'first' && this.nextRequiredImage('second')) {
        return '裏面を撮影する'
      } else {
        return '提出する'
      }
    },
    testInfo(): TestInfo | null {
      return this.$store.state.submittingTestInfo as TestInfo
    },
    // 今処理しているテスト面に期待されるQRコード
    currentDesiredQrCode(): string {
      if (!this.testInfo) {
        return ''
      }
      const examGroupKey = this.testInfo.exam_group_key
      const sideKey = this.imageType === 'first' ? '11' : '22'
      return `0${examGroupKey}${sideKey}`
    },
    // 今処理しているテスト面の補正用データ
    qrInfo(): QRInfo {
      const qr = QR_MAP.get(this.currentDesiredQrCode)
      // 定義されていない場合(ありえないはず)は空データを返す
      const emptyData = {
        checkDigit: 0,
        correctSize: { w: 0, h: 0 },
        correctMarkers: {
          bl: { x: 0, y: 0 },
          br: { x: 0, y: 0 },
          tl: { x: 0, y: 0 },
          tr: { x: 0, y: 0 }
        },
        asGray: false,
        rotateQrPos: {
          x: 0,
          y: 0
        },
        numCheckPosition: { l: 0, t: 0, w: 0, h: 0 }
      }
      return qr as QRInfo || emptyData
    },
    faqQrNotReadablePath(): string {
      if (this.displayForMember) return `${process.env.VUE_APP_ROOT_PATH}/participant/faq/cate05/r.html`
      return `/tensaku_visiter/faq/${this.$store.state.examInfo.examGroupKey}/${this.$store.state.examInfo.qrFaqId}`
    },
    isShowRotateButton(): boolean {
      return !this.qrInfo.rotateQrPos
    }
  },
  mounted() {
    // 提出完了時にテストデータがクリアされたあと履歴から遷移した場合
    if (this.testInfo == null) {
      this.changeState('Complete')
      return
    }
    // ステップ数の計算
    this.stepps = this.calculateStepps()
    // 最初の撮影する必要がある面
    this.imageType = this.nextRequiredImage('first')
  },
  methods: {
    changeState(nextState: State) {
      // (document.activeElement as HTMLInputElement)?.blur()
      window.scrollTo(0, 0)
      this.state = nextState
      if (nextState !== 'Complete') {
        // nextTickだけだとうまくいかない場合がある（特に裏面QRへの遷移)のでsetTimeoutを使う
        this.$nextTick(() => {
          setTimeout(() => {
            const anchor = this.$refs.scrollAnchor as HTMLInputElement
            anchor.scrollIntoView({ behavior: 'smooth' })
          }, 200)
        })
      }
    },
    handleResize(): void {
      this.width = window.innerWidth
    },
    backToSubmitTest(): void {
      // テスト選択画面→提出方法画面→提出画面と来ているはずなので
      if (window.history.length > 2) {
        this.$router.go(-2)
      } else {
        this.$router.push(this.submitTestPath)
      }
    },
    openModal(): void {
      this.showSubmit = true
    },
    closeModal(): void {
      this.showSubmit = false
    },
    // ステップの数の計算
    // 未提出 ステップ数 = 9 or 再提出片面のみ ステップ数 = 5
    calculateStepps(): string[][] {
      const SortNoToImageType = { 1: 'first', 2: 'second' }

      let imageTypes = this.testInfo!.individual_data
        .filter((info: IndividualTestStatus) => ['未提出', '差し戻し'].includes(info.status))
        .map((info: IndividualTestStatus) => {
          return SortNoToImageType[info.sort_no]
        })

      // WEB完結型は表面だけ
      if (!this.isMAGAZINE && imageTypes.length) {
        imageTypes = ['first']
      }

      const states = ['QR', 'Picture', 'Preview', 'NumCheck']
      let totalStepps = imageTypes.map(type => {
        return states.map(state => [type, state])
      }).flat()
      totalStepps.push(['Complete'])
      return totalStepps
    },
    async openQRModal(): Promise<void> {
      this.showQRModal = true
      this.showQRTimeout = setTimeout(() => {
        this.errorMessage = '二次元コードの読み取りに失敗しました。'
        this.showQRModal = false
      }, 15000)
    },
    /**
     * QRスキャン成功時
     */
    qrReaderScanned(value: string) {
      clearTimeout(this.showQRTimeout)
      this.showQRTimeout = null
      this.showQRModal = false

      this.processQRCode(value)
    },
    processQRCode(qrCode: string) {
      if (qrCode === this.currentDesiredQrCode) {
        // 期待するコードだった場合
        this.changeState('Picture')
        this.errorMessage = ''
      } else {
        // 期待したものと違うコードだった場合
        this.errorMessage =
          `二次元コードに間違いがないか確認のうえ、もう一度読み取ってください。`
      }
    },
    async openPictureModal(): Promise<void> {
      this.showPictureModal = true
    },
    async reTake(): Promise<void> {
      document.querySelector('.ilustrated-submit-ok')?.removeAttribute('src')
      this.base64ImageUrl = ''
      this.changeState('Picture')
      this.errorMessage = ''
      await this.$nextTick()
    },
    submitNumber() :void | string {
      if (this.uploading) return
      if (!this.cutOutNumber)
        return (this.cutOutNumberError = '数字を入力してください。')
      if (this.cutOutNumber != this.qrInfo.checkDigit.toString())
        return (this.cutOutNumberError =
          '表示されている数字を正しく入力してください。<br>' +
          '数字が表示されていない、もしくは数字が読み取れない、数字が読み取りにくいなどの場合は再撮影をお願いします。')
      this.errorMessage = ''
      this.cutOutNumberError = ''
      this.submitedImage()
    },
    // nextImageSortNumberかそれより後ろで、撮影の必要があるものを返す なければnull
    nextRequiredImage(nextImageType: ImageType): ImageType {
      let restImageTypes: ImageType[] = nextImageType === 'first'
        ? ['first', 'second']
        : ['second']
      const imageTypeToSortNo = {
        '': -1,
        first: 1,
        second: 2,
      }

      const next = restImageTypes.find(imageType => {
        const checking = this.testInfo!.individual_data.find(x =>
          x.sort_no === imageTypeToSortNo[imageType])
        return checking && ['未提出', '差し戻し'].includes(checking.status)
      })
      return next || ''
    },
    async submitedImage(): Promise<void> {
      let nextImageType: ImageType = ''
      if (!this.isMAGAZINE) {
        this.submittedBase64ImageUrl[0] = this.base64ImageUrl
        nextImageType = ''
      } else if (this.imageType === 'first') {
        this.submittedBase64ImageUrl[0] = this.base64ImageUrl
        nextImageType = this.nextRequiredImage('second')
      } else if (this.imageType === 'second') {
        this.submittedBase64ImageUrl[1] = this.base64ImageUrl
        nextImageType = ''
      }

      if (nextImageType) {
        // まだ撮影が残っている場合
        this.imageType = nextImageType
        this.changeState('QR')
      } else {
        // 撮影が完了した場合
        const error = await this.sendData()
        if (error) {
          this.errorMessage = error
        } else {
          this.changeState('Complete')
          this.imageType = ''
          // 処理が完了したタイミングでテスト情報はクリアする
          this.$store.commit('SET_SUBMITTING_TEST_INFO', null)
        }
      }
    },
    // バックエンドにテスト画像を登録
    async sendData(): Promise<string | null> {
      let isSuccess = true
      this.uploading = true
      try {
        this.submittedBase64ImageUrl = this.submittedBase64ImageUrl.map((v) => v === null ? '' : v)
        const res = await axios.post(
          `/api/v1/submit/tests/${this.testInfo!.exam_group_key}`,
          { images: this.submittedBase64ImageUrl }
        )
      } catch(error) {
        isSuccess = false
      } finally {
        this.uploading = false
      }
      if (isSuccess) {
        return null
      } else {
        return 'アップロードに失敗しました。'
      }
    },

    /**
     * 答案用紙を作成する
     */
    async takePicture(payload: {
      canvas: HTMLCanvasElement
      l: number
      t: number
      w: number
      h: number
    }) {
      const { canvas, l, t, w, h } = payload

      this.uploading = true

      try {
        let clippedBase64 = await PictureUtil.clip(canvas, { l, t, w, h })
        PictureUtil.disposeCanvas(canvas)

        // Bansheeへリクエストを投げる
        const {
          result,
          image: correctedBase64,
          auto_rotate_qr
        } = await PictureUtil.correctImage(
          clippedBase64,
          this.qrInfo.correctSize,
          this.qrInfo.correctMarkers,
          this.qrInfo.asGray,
          this.qrInfo.rotateQrPos,
          false,
          // this.qrInfo.disableWhitebarance
        )
        clippedBase64 = ''

        if (result !== 'ok') {
          throw new Error(
            'テスト紙面の四隅の■マークが読み取れませんでした。もう一度撮影をやり直してください'
          )
        }

        // デバッグ用
        // PictureUtil.downloadBase64Image(base64, 'クリップ前')
        // PictureUtil.downloadBase64Image(clippedBase64, 'クリップ後')
        // PictureUtil.downloadBase64Image(correctedBase64, '補正後')

        // プレビュー画面へ
        this.showPictureModal = false
        this.changeState('Preview')
        this.base64ImageUrl = `data:image/jpeg;base64,${correctedBase64}`
      } catch (err) {
        if (err instanceof Error) {
          (this as any).$refs['show-picture-alert-modal'].show(err.message)
        }
        console.error(err)
        // this.showPictureModal = false
        // this.state === 'Picture'
      } finally {
        PictureUtil.disposeCanvas(canvas)
        this.uploading = false
      }
    },

    async showNumCheck() {
      const { l, t, w, h } = this.qrInfo.numCheckPosition
      // 数字の部分をクリップする
      const base64 = PictureUtil.base64UrlToBase64(this.base64ImageUrl)
      const clippedBase64 = await PictureUtil.clip(base64, { l, t, w, h })
      this.numCheckImageUrl = `data:image/jpeg;base64,${clippedBase64}`
      this.cutOutNumber = ''
      this.changeState('NumCheck')
    },

    async rotate() {
      this.rotating = true
      try {
        const base64 = await PictureUtil.rotate180(
          PictureUtil.base64UrlToBase64(this.base64ImageUrl)
        )
        this.base64ImageUrl = `data:image/jpeg;base64,${base64}`
      } finally {
        this.rotating = false
      }
    },

    /**
     * ダミーの画像選択処理
     */
    async dummyTakePicture(e: Event) {
      e.preventDefault()
      const files = (e.target as HTMLInputElement).files
      if (files) {
        if (files.length === 0) {
          return
        }
        const file = files[0]
        this.base64ImageUrl = await PictureUtil.toBase64Url(file)
        this.showPictureModal = false
        this.changeState('Preview')
      }
    },

    /**
     * ダミーのQRコード処理
     */
    readDummyQRCode() {
      this.processQRCode(this.dummyQRCode)
    }
  }
})
